import React from "react";

function Kochi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20.4171 13.3662V16.4039H3.57152V13.3662C2.94033 13.5044 2.38235 13.8708 2.00453 14.3949C1.6267 14.9191 1.45561 15.5643 1.52404 16.2068C1.59246 16.8493 1.89559 17.444 2.37534 17.8768C2.85508 18.3097 3.47769 18.5502 4.12384 18.5524H19.8648C20.511 18.5502 21.1336 18.3097 21.6133 17.8768C22.093 17.444 22.3962 16.8493 22.4646 16.2068C22.533 15.5643 22.3619 14.9191 21.9841 14.3949C21.6063 13.8708 21.0483 13.5044 20.4171 13.3662Z"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M18.6799 16.3903H5.56245V13.3663L5.01013 11.9248H19.2322L18.6799 13.3663V16.3903Z"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M6.73694 12.4771H17.7501"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M16.0765 11.9251C15.2232 11.1602 13.7678 10.6548 12.1109 10.6548C10.4539 10.6548 8.99859 11.1602 8.14526 11.9251H16.0765Z"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M14.4881 16.3905V16.3601C14.4881 15.7273 14.2367 15.1204 13.7892 14.673C13.3418 14.2255 12.7349 13.9741 12.1021 13.9741C11.4693 13.9741 10.8624 14.2255 10.4149 14.673C9.96744 15.1204 9.71606 15.7273 9.71606 16.3601V16.3905H14.4881Z"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M17.6585 16.3902V16.3737C17.6585 16.0573 17.5328 15.7538 17.309 15.5301C17.0853 15.3064 16.7819 15.1807 16.4655 15.1807C16.1491 15.1807 15.8456 15.3064 15.6219 15.5301C15.3982 15.7538 15.2725 16.0573 15.2725 16.3737V16.3902H17.6585Z"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M8.93251 16.3902V16.3737C8.93251 16.0573 8.80682 15.7538 8.58309 15.5301C8.35936 15.3064 8.05591 15.1807 7.73951 15.1807C7.4231 15.1807 7.11966 15.3064 6.89593 15.5301C6.6722 15.7538 6.54651 16.0573 6.54651 16.3737V16.3902H8.93251Z"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M3.11258 13.3662C3.11258 13.3662 1.69589 6.628 5.66703 4.39941"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M2.42285 5.46559C3.31521 4.21128 4.64551 3.33723 6.15098 3.01607C8.60049 2.46376 11.6741 7.19157 11.6741 7.19157L8.52041 5.81355L7.53176 10.2818L7.04849 4.39962L4.37805 9.26551C4.37805 9.26551 5.65665 4.67578 6.34705 3.84731L2.42285 5.46559Z"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M21.2628 13.5323C21.2628 13.5323 22.6795 6.79402 18.7084 4.56543"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M21.9525 5.63405C21.0601 4.37975 19.7298 3.5057 18.2243 3.18454C15.7748 2.63222 13.5297 6.99827 13.5297 6.99827L15.8466 5.97925L16.7856 9.50854L17.3379 4.56532L19.5471 8.61379C19.5471 8.61379 18.7187 4.84148 18.0255 4.01301L21.9525 5.63405Z"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M21.9531 18.7817H22.7208"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M12.2435 18.7817H20.3736"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M5.01013 18.7817H9.96992"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M1.5 18.7817H3.527"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M22.2118 19.9971H22.7187"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M17.7494 19.9971H20.9694"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M8.58936 19.9971H12.1214H12.7787H13.527H16.4654"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M1.5 19.9971H7.048"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M21.9531 21.2119H22.7208"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M20.1074 21.2119H21.0629"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M14.4879 21.2119H18.7076"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M7.04797 21.2119H12.1017"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
      <path
        d="M1.5 21.2119H4.72276"
        stroke="#17142A"
        strokeWidth="0.367325"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoKochi = React.memo(Kochi);
export default MemoKochi;
